export class BrowserPlatform implements IPlatform {
    private _afkCbs: ((afkState: boolean) => void)[];
    state: PlatformState;
    private _ac: AbortController;

    constructor() {
        this._afkCbs = [];
        this.state = {
            isAfk: false,
        };
        this._ac = new AbortController();
        this.setup();
    }

    on = {
        afk: (cb: AFKCb) => {
            this._afkCbs.push(cb);
        },
    };
    off = {
        afk: (cb: AFKCb) => {
            this._afkCbs = this._afkCbs.filter((t) => t !== cb);
        },
    };

    get name(): string {
        return "browser";
    }

    async setup() {
        const ac = new AbortController();
        document.addEventListener(
            "click",
            async () => {
                ac.abort();

                try {
                    const permission = await IdleDetector.requestPermission();
                    if (permission !== "granted") {
                        return;
                    }

                    const detector = new IdleDetector();
                    detector.addEventListener(
                        "change",
                        (d) => {
                            const isAfk =
                                d.userState === "idle" ||
                                d.screenState === "locked";
                            this.state.isAfk = isAfk;
                            for (const cb of this._afkCbs) {
                                cb(isAfk);
                            }
                        },
                        this._ac,
                    );
                } catch (e) {
                    console.log("error while setting up idle detector", e);
                }
            },
            ac,
        );
    }

    dispose() {
        this._ac.abort();
    }
}
